import "./App.css";
import Navbar from "./components/Navbar";


import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Footer from "./components/Footer";
import Menu from "./pages/Menu";
import Contact from "./pages/Contact";

function App() {
  return (
    <>
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
        <Route path="/" index element={<Home />} />
        <Route path="/menu" index element={<Menu />} />
        <Route path="/about" index element={<About />} />
        <Route path="/contact" index element={<Contact />} />
        </Routes>

        <Footer />
      </Router>
    </div>
    </>
  );
}

export default App;
